<template>
    <div class="mt-4 mb-2 ml-3">
        <div class="layout row mb-2">
            <div class="font-weight-medium mr-1 width-200">
                Date:
            </div>
            <div>{{ row.date | time }}</div>
        </div>
        <div class="layout row mb-2" v-if="row.processedDate">
            <div class="font-weight-medium mr-1 width-200">
                Processed Date:
            </div>
            <div>{{ row.processedDate | time }}</div>
        </div>
        <div class="layout row mb-2" v-if="row.dateCreated">
            <div class="font-weight-medium mr-1 width-200">
                Date Created:
            </div>
            <div>{{ row.dateCreated | time }}</div>
        </div>

        <div
            class="layout row mb-2"
            v-if="row.userName && row.userName != 'Anonymous'"
        >
            <div class="font-weight-medium mr-1 width-200">User:</div>
            <div>{{ row.userName }}</div>
        </div>
        <div class="layout row mb-2" v-if="row.status == 'ERROR'">
            <div class="font-weight-medium mr-1 width-200">Error Message:</div>
            <div class="text-danger">{{ row.transactionResult }}</div>
        </div>
        <div class="layout row mb-2">
            <div class="font-weight-medium mr-1 width-200">
                Imported:
            </div>
            <div>{{ row.isImported ? "Yes" : "No" }}</div>
        </div>

        <div class="layout row mb-2" v-for="prop in getRowProperties()">
            <div class="font-weight-medium mr-1 width-200">
                {{ prop.name }}:
            </div>
            <div>{{ prop.value }}</div>
        </div>

        <div class="mt-5" v-if="row.details || row.scheduleDetails">
            <div class="font-weight-medium mb-2 layout row">
                Payment Details
            </div>
            <div
                class="layout row mb-2"
                v-for="detail in getPaymentDetails(row.details)"
                v-if="row.details || row.scheduleDetails"
            >
                <div class="font-weight-medium mr-1">
                    {{ detail.category }}:
                </div>
                <div>${{ detail.amount }}</div>
            </div>
        </div>

        <div class="mt-5" v-if="row.refunds">
            <div class="font-weight-medium mb-2 layout row">Refunds</div>
            <div class="layout row mb-2" v-for="detail in getRefundDetails()">
                <div class="font-weight-regular mr-2">{{ detail.date }}:</div>
                <div class="text-danger">${{ detail.amount }}</div>
            </div>
        </div>

        <div class="layout row mb-2">
            <v-btn
                v-if="
                    (row.status == 'DECLINED' || row.status == 'ERROR') &&
                        (row.tranType == 'Sale' || !row.tranType)
                "
                small
                class="mr-2"
                color="success"
                @click="confirmProcessAgainDialog = true"
                >Process Again</v-btn
            ><v-btn
                small
                color="success"
                class="mr-2"
                @click="confirmChargeNowDialog = true"
                v-if="
                    (row.status == 'SCHEDULED' ||
                        row.status == 'SCHEDULED PAST DUE') &&
                        ['Credit Card', 'CC'].includes(row.paymentType)
                "
                >Charge Now</v-btn
            ><v-btn
                small
                color="success"
                class="mr-2"
                @click="openUpdateScheduleDateDialog"
                v-if="row.status == 'SCHEDULED'"
                >Update Schedule Date</v-btn
            >
            <v-btn
                small
                color="success"
                class="mr-2"
                @click="confirmEnableScheduleDialog = true"
                v-if="row.status == 'SCHEDULED' && row.scheduleDisabled"
                >Enable Schedule</v-btn
            >
            <v-btn
                small
                color="success"
                @click="confirmHideTransactionDialog = true"
                >Hide Transaction</v-btn
            >
        </div>

        <v-dialog
            persistent
            v-model="confirmProcessAgainDialog"
            max-width="400"
        >
            <v-card class="pa-3">
                <div class="headline">Are you sure?</div>
                <div class="my-3">
                    This will reprocess the payment of
                    {{ row.amount | currency }}
                </div>
                <v-card-actions class="pb-0 mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="confirmProcessAgainDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="processAgain()"
                        >Confirm</v-btn
                    >
                </v-card-actions></v-card
            >
        </v-dialog>

        <v-dialog
            persistent
            v-model="confirmEnableScheduleDialog"
            max-width="400"
        >
            <v-card class="pa-3">
                <div class="headline">Are you sure?</div>
                <div class="my-3">
                    This will enable the payment of
                    {{ row.amount | currency }} scheduled on
                    {{ row.date | date }}
                </div>
                <v-card-actions class="pb-0 mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="confirmEnableScheduleDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="enableSchedule()"
                        >Confirm</v-btn
                    >
                </v-card-actions></v-card
            >
        </v-dialog>

        <v-dialog persistent v-model="confirmChargeNowDialog" max-width="400">
            <v-card class="pa-3">
                <div class="headline">Are you sure?</div>
                <div class="my-3">
                    This will process the scheduled payment of
                    {{ row.amount | currency }}
                </div>
                <v-card-actions class="pb-0 mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="confirmChargeNowDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="processNow()"
                        >Process</v-btn
                    >
                </v-card-actions></v-card
            >
        </v-dialog>

        <v-dialog
            persistent
            v-model="confirmHideTransactionDialog"
            max-width="400"
        >
            <v-card class="pa-3">
                <div class="headline">Are you sure?</div>
                <div class="my-3">
                    This will hide the transaction of
                    <span class="font-weight-medium"
                        >{{ row.name + "-" }} {{ row.date | date }}
                        {{ ("-" + row.amount) | currency }}
                    </span>
                </div>
                <v-card-actions class="pb-0 mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="confirmHideTransactionDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="hideTransaction()"
                        >Hide</v-btn
                    >
                </v-card-actions></v-card
            >
        </v-dialog>

        <v-dialog persistent v-model="updateScheduleDateDialog" max-width="400">
            <v-card class="pa-3">
                <div class="headline mb-3">Update Schedule Date</div>
                <v-menu
                    v-model="datePickerMenu"
                    :close-on-content-click="true"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="row.scheduleDate"
                            label="Schedule Date"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        :min="today"
                        v-model="row.scheduleDate"
                    ></v-date-picker>
                </v-menu>
                <v-card-actions class="pb-0 mr-0 mt-1">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateScheduleDateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="updateScheduleDate()"
                        >Save</v-btn
                    >
                </v-card-actions></v-card
            >
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, sum, toISOLocal } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            confirmProcessAgainDialog: false,
            confirmChargeNowDialog: false,
            confirmHideTransactionDialog: false,
            confirmEnableScheduleDialog: false,
            updateScheduleDateDialog: false,
            datePickerMenu: false,
            today: toISOLocal(new Date(moment())).substr(0, 10),
            processing: false,

            categories: new Map([
                ["TC", "Tuition"],
                ["TRNS", "Transportation"],
                ["LAPC", "Lapidus"],
            ]),
        };
    },
    async created() {},
    computed: {},
    methods: {
        getPaymentDetails() {
            if (!this.row.details && !this.row.scheduleDetails) return;

            const details = this.row.details
                ? this.row.details
                : this.row.scheduleDetails;

            return details.split("|").map((detail) => {
                const category = detail.split(":")[0];
                const amount = detail.split(":")[1];

                return {
                    category: this.getCategoryName(category),
                    amount,
                };
            });
        },
        getCategoryName(category) {
            return category == "TC"
                ? "Tuition"
                : category == "TRNS"
                ? "Transportation"
                : category;
        },
        getRefundDetails() {
            if (!this.row.refunds) return;

            return this.row.refunds.split("|").map((detail) => {
                const date = this.formatTime(detail.split(",")[0]);
                const amount = detail.split(",")[1];

                return {
                    date,
                    amount,
                };
            });
        },
        getRowProperties() {
            return Object.keys(
                except(
                    this.row,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "userName",
                    "details",
                    "refunds",
                    "date",
                    "scheduleDetails",
                    "isImported",
                    "processedDate",
                    "dateCreated",
                ),
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: this.row[key],
                    };
                })
                .filter((p) => p.value);
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        async processAgain() {
            try {
                this.processing = true;

                let data = {};

                data = {
                    user: this.$store.state.authentication.user,
                    scheduleDetailID: this.row.scheduleDetailID,
                };

                //data.payment.paymentID = row.paymentLogID;

                const response = await this.$http.post(
                    "api/unprocessedPayments/processAgain",
                    data,
                );

                this.$notify({
                    text: "Payment " + response.transactionResult,
                    group: "notification",
                    type: response.resultCode == "A" ? "success" : "error",
                });

                this.confirmProcessAgainDialog = false;

                this.reloadGrid();

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async processNow() {
            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/schedules/processSchedule?scheduleDetailID=" +
                        this.row.scheduleDetailID,
                );

                this.$notify({
                    text: "Payment " + response.transactionResult,
                    group: "notification",
                    type: response.resultCode == "A" ? "success" : "error",
                });

                this.confirmChargeNowDialog = false;

                this.reloadGrid();

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        openUpdateScheduleDateDialog() {
            this.row.scheduleDate = new Date(this.row.date)
                .toISOString()
                .substr(0, 10);

            this.updateScheduleDateDialog = true;
        },
        async updateScheduleDate() {
            if (!this.row.scheduleDate) {
                return this.$notify({
                    text: "Schedule Date Required",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/schedules/updateScheduleDate?scheduleDetailID=" +
                        this.row.scheduleDetailID +
                        "&scheduleDate=" +
                        this.row.scheduleDate +
                        "&txnID=" +
                        this.row.txnID +
                        "&user=" +
                        this.$store.state.authentication.user,
                );

                this.$notify({
                    text: "Schedule Date Updated",
                    group: "notification",
                    type: "success",
                });

                this.updateScheduleDateDialog = false;

                this.reloadGrid();

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async hideTransaction() {
            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/unprocessedPayments/hideTransaction?txnID=" +
                        this.row.txnID,
                );

                this.$notify({
                    text: "Transaction successfully hidden.",
                    group: "notification",
                    type: "success",
                });

                this.confirmHideTransactionDialog = false;

                this.reloadGrid();

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async enableSchedule() {
            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/schedules/enableSchedule?scheduleDetailID=" +
                        this.row.scheduleDetailID,
                );

                this.$notify({
                    text: "Schedule Enabled",
                    group: "notification",
                    type: "success",
                });

                this.confirmEnableScheduleDialog = false;

                this.reloadGrid();

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        viewSchedule() {
            this.$router.push({
                name: "AccountView",
                params: {
                    id: this.row.accountID,
                },
                query: {
                    schedule: this.row.scheduleDetailId,
                },
            });
        },
        viewPayment() {
            this.$router.push({
                name: "Account View",
                params: {
                    id: this.row.accountID,
                },
                query: {
                    payment: this.row.paymentID.toString(),
                },
            });
        },
    },
};
</script>
<style></style>
